import React from 'react';
import { Toast, Icon } from 'antd-mobile';
import { Tabs, ActivityIndicator } from 'antd-mobile';

import { getAppId } from '@utils/global';
import { ajax } from '@utils/http';
import { cssObj2DomObj, transformPx2Rem, convertStyleData } from '@utils/tools';

import './TostoreCustomComponent.less';


/**
 * type: "tostore" 
 * 组件：到店组件
 * TODO: 购物车加菜减菜待完成；评价列表待完成；店铺信息待完成；
 */

export default class TostoreCustomComponent extends React.Component {
  state = {
    storeInfo: {},
    category: [],
    goodsList: [],
    AssessList: [],
    categoryName: '',
    loading: false,
    selectId: '',
    selectIndex: 0,
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // 组件数据
    const data = this.props.data;
    console.log(data);
    // 组件配置对象
    const customFeature = data.customFeature;
    const content = data.content;

    this.getStoreInfo().then(() => {
      if (customFeature.databind === '1') {
        this.getCategory().then(() => {
          this.setState({
            selectId: this.state.category[0]['id'],
            categoryName: this.state.category[0]['name'],
          })
          this.getGoodsList();
        })
      } else {
        this.setState({
          selectId: content[0]['source'],
          categoryName: content[0]['text'],
        })
        this.getGoodsList();
      }
    })
  }

  // 获取到店店铺信息
  getStoreInfo = () => {
    let param = {
      app_id: getAppId(),
    }
    return new Promise((resolve) => {
      ajax({
        url: '/index.php?r=AppShop/GetTostoreWaitingRule',
        data: param,
        success: (res) => {
          if (res.status !== 0) {
            Toast.info(res.data);
            return;
          }
          this.setState({
            storeInfo: res.data,
          });
          resolve();
        },
      });
    })
  }

  // 获取到店商品分类信息
  getCategory = () => {
    let param = {
      app_id: getAppId(),
      goods_type: 3,
      filter_null: 1,
    }
    return new Promise((resolve) => {
      ajax({
        url: '/index.php?r=AppShop/getGoodsCategory',
        data: param,
        success: (res) => {
          if (res.status !== 0) {
            Toast.info(res.data);
            return;
          }
          if (res.data.length!==0) {
            this.setState({
              category: res.data,
            });
            resolve();
          }
        },
      });
    })
  }

  // 获取到店商品信息
  getGoodsList = () => {
    this.setState({loading: true});
    let option = {
      idx_arr : {
        idx: 'category',
        idx_value: this.state.selectId === 'all' ? '' : this.state.selectId,    // 传all的时候替换为'';
      }
    }
    let param = {
      app_id: getAppId(),
      goods_type: 2,
      form: 'tostore',
      page: 1,
      page_size: 10,
      is_integral: 5,
      sort_key: '',
      sort_direction: 0,
      ...option,
    }
    return new Promise((resolve) => {
      ajax({
        url: '/index.php?r=AppShop/GetGoodsList',
        data: param,
        success: (res) => {
          if (res.status !== 0) {
            Toast.info(res.data);
            return;
          }
          this.setState({
            goodsList: res.data,
            loading: false,
          });
          resolve();
        },
      });
    })
  }

  // 获取评论列表 
  getAssessList = () => {
    let param = {
      app_id: getAppId(),
      goods_type: 2,
      page: 1,
      page_size: 10,
    }
    return new Promise((resolve) => {
      ajax({
        url: '/index.php?r=AppShop/getAssessList',
        data: param,
        success: (res) => {
          if (res.status !== 0) {
            Toast.info(res.data);
            return;
          }
          console.log(res.datta);
          this.setState({
            AssessList: res.data,
          });
          resolve();
        },
      });
    })
  }

  switchCategory = (id, name, index) => {
    if (this.state.selectId !== id || this.state.selectIndex !== index) {
      this.setState({selectId: id, selectIndex: index, categoryName: name, goodsList: []}, () => {
        this.getGoodsList();
      });
    }
  }

  render() {
    // 组件数据
    const data = this.props.data;
    // 组件配置对象
    const customFeature = data.customFeature;
    // 商品分类
    const content = data.content;
    const tabs = [{ title: '商品' }, { title: '评价' }, { title: '店铺' },]
    // 组件样式
    const topStyle = cssObj2DomObj(customFeature.style);
    const logoRadius = transformPx2Rem(customFeature.logoRadius);
    const categoryStyle = convertStyleData(customFeature.leftSpan);
    categoryStyle['paddingLeft'] = transformPx2Rem(customFeature.typeLeft,320);
    let selectStyle = {
      backgroundColor: customFeature.selectedBackgroundColor,
      color: customFeature.selectedColor,
      borderLeft: '4px solid #ff7100',
      paddingLeft: transformPx2Rem(customFeature.typeLeft,320)
    }
    const underlineStyle = {
      border: '1px solid #ff7100',
      transform: 'scale(0.5, 1)',
    }
    return (
      <div className="custom-component tostore">
        {/* <div className="pos">广东省深圳市南山区桃园路2号</div> */}
        {/* 判断是否显示店铺信息 */}
        {customFeature.showShopInfo &&
          <div className="header">
            {customFeature.mode == '0' &&
              <div className="shop-desc-mode-0">
                <div className="info-wrap">
                  <div className="logo" style={{ borderRadius: logoRadius }}>
                    <img src={this.state.storeInfo.logo} alt="" />
                  </div>
                  <div className="shop-info">
                    <div className="msg" style={{ color: customFeature.storeSecColor }}>
                      营业时间为：
                    </div>
                    <div className="address" style={{ color: customFeature.storeSecColor }}>
                      <span>店铺地址：{this.state.storeInfo.address_detail}</span>
                    </div>
                  </div>
                </div>
                <div className="line"></div>
              </div>
            }
            {customFeature.mode == '1' &&
              <div className="shop-desc-mode-1">
                <div className="top" style={topStyle}>
                  <div className="logo" style={{ borderRadius: logoRadius }}>
                    <img src={this.state.storeInfo.logo} alt="" />
                  </div>
                </div>
                <div className="info-wrap">
                  <div className="msg" style={{ color: customFeature.storeSecColor }}>
                    营业时间为：
                  </div>
                  <div className="address" style={{ color: customFeature.storeSecColor }}>
                    <span>店铺地址：{this.state.storeInfo.address_detail}</span>
                  </div>
                </div>
                <div className="line"></div>
              </div>
            }
            {customFeature.mode == '2' &&
              <div className="shop-desc-mode-2">
                <div className="top" style={topStyle}></div>
                <div className="info">
                  <div className="msg" style={{ color: customFeature.storeSecColor }}>
                    营业时间为：
                  </div>
                  <div className="address" style={{ color: customFeature.storeSecColor }}>
                    <span>店铺地址：{this.state.storeInfo.address_detail}</span>
                  </div>
                </div>
                <div className="logo" style={{ borderRadius: logoRadius }}>
                  <img src={this.state.storeInfo.logo} alt="" />
                </div>
              </div>
            }
          </div>
        }
        <div className="tab">
          <Tabs tabs={tabs}
            tabBarActiveTextColor="#ff7100"
            tabBarUnderlineStyle={underlineStyle}
          >
          <div className="goods-wrap" style={{height:'100%'}}>
            <div className="sort-list">
              {customFeature.databind === '0' && content.map((categoryData, index) => 
                <div className="sort-item"
                  key={index}
                  onClick={() => this.switchCategory(categoryData.source, categoryData.text, index)}
                  style={this.state.selectIndex === index ? selectStyle : categoryStyle}
                >
                {categoryData.text}</div>
              )}
              {customFeature.databind === '1' && this.state.category.map((categoryData, index) => 
                <div className="sort-item"
                  key={index}
                  onClick={() => this.switchCategory(categoryData.id, categoryData.name)}
                  style={this.state.selectId === categoryData.id ? selectStyle : categoryStyle}
                >
                {categoryData.name}</div>
              )}
            </div>
            <div className="goods-list">
              <div className="goods-sort">{this.state.categoryName}</div>
              <ActivityIndicator animating={this.state.loading} size="large" />
              {this.state.goodsList.map((goodsData) => 
                <div className="goods-type" key={goodsData.form_data.id}>
                  <div className="goods-item">
                    <img src={goodsData.form_data.cover} alt=""/>
                    <div className="goods-info">
                      <div className="goods-top">
                        <div className="title">
                          {goodsData.form_data.title}
                        </div>
                        <div className="sales">
                          销量：{goodsData.form_data.sales}
                        </div>
                      </div>
                      <div className="goods-bottom">
                        <div className="price">
                          <span className="real-price">￥{goodsData.form_data.goods_price}</span>
                          {customFeature.isShowVirtualPrice && 
                            <span className="virtual-price">￥{goodsData.form_data.virtual_price}</span>
                          }
                        </div>
                        <div className="buy-btn">+</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="assess-wrap" style={{height:'500px'}}>
            {this.state.AssessList.length === 0 && 
              <div className="no-assess">
                <img src="https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/moreAssess.png" alt=""/>
                <div>暂无任何评价</div>
              </div>
            }
            {this.state.AssessList.length !== 0 && 
              <div className="assess-list">
                {/* TODO: 评价未处理 */}
              </div>
            }
          </div>
          <div className="shop-wrap" style={{height:'500px'}}>
            <div className="merchant-info">
              <div className="info-title">商家信息</div>
              <div className="info-content">
                <div className="info-item">
                  <i className="icon-fesadress"></i>
                  {this.state.storeInfo.address_detail}
                </div>
                <div className="info-item">
                  <i className="icon-tokeout-info"></i>
                  {this.state.storeInfo.description}
                </div>
                <div className="info-item">
                  <i className="icon-sales-num"></i>
                  月售{this.state.storeInfo.total_sales}份
                </div>
                <div className="info-item">
                  <i className="icon-business-time"></i>
                  营业时间为：00:00-23:59
                </div>
              </div>
            </div>
          </div>
          </Tabs>
        </div>
        <div className="bottom">
          <div className="money-count">
            <div className="cart-wrap">
              <i className="icon icon-fn-cart"></i>
            </div>
            <div>请选择商品</div>
          </div>
          <div className="order-btn">去下单</div>
        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/custom-component/tostore-custom-component/TostoreCustomComponent.jsx